module.exports = __webpack_public_path__ + "fonts/buttonedit.svg?bf4fa697";